import { usePopup } from "@/app/hooks/use_popup"
import { Button } from "@/components/buttons/button"

interface MessagePopupProps {
  isOpen: boolean
  title: string
  message?: string
  close: () => void
  children?: React.ReactNode
}

export function MessagePopup({
  title,
  message,
  isOpen,
  close,
  children,
}: MessagePopupProps) {
  const { popupRef, closePopup } = usePopup(isOpen, close)

  const renderMessage = (message: string) => {
    const lines = message.split(".")
    return lines.map((line, index) => (
      <div key={index} className="mt-1 px-4 text-left text-sm text-main-dark">
        {line.trim()}
        {index !== lines.length - 1 ? "." : ""}
      </div>
    ))
  }

  if (!isOpen) return null

  return (
    <>
      <div className="fixed inset-0 z-20 overflow-y-auto">
        <div
          className={`fixed inset-0 bg-main-700/50 transition-opacity duration-300 ${
            isOpen ? "opacity-100" : "opacity-0"
          }`}
        />
        <div
          ref={popupRef}
          className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:px-2">
          <div
            className={`${isOpen ? "visible opacity-100" : "opacity-0"} relative min-h-32 max-w-[30rem] -translate-y-3/4 rounded-3xl border border-main-400 bg-main-light p-3 text-left transition-opacity duration-300 ease-in-out data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-300 data-[enter]:ease-out data-[leave]:ease-in xl:-right-[120px]`}
            onClick={(e) => e.stopPropagation()}>
            <div className="flex flex-col items-center gap-3">
              <div className="mb-0 text-center text-lg font-bold text-main-dark">
                {title}
              </div>
              <div>{message ? renderMessage(message) : null}</div>
              <div className="flex items-center gap-2 py-2">
                {children}
                <Button color="tertiary" onClick={() => closePopup()}>
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
